import palette from './palette';

export default {
  fontFamily: 'Raleway, Arial',
  h1: {
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    fontWeight: '700',
    color: '#4A4A4A',
    fontSize: '32px',
    lineHeight: '120%',
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  h2: {
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    fontWeight: '500',
    color: '#4A4A4A',
    fontSize: '24px',
    lineHeight: '125%',
    fontFeatureSettings: '"pnum" on, "lnum" on'
  },
  h3: {
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    fontWeight: '500',
    color: '#4A4A4A',
    fontSize: '18px',
    lineHeight: '140%',
    fontFeatureSettings: '"pnum" on, "lnum" on'
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: '24px',
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '25px',
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px',
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  body1: {
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    fontWeight: '500',
    color: '#8A8A8D',
    fontSize: '16px',
    lineHeight: '150%',
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  body2: {
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    fontWeight: '500',
    color: '#8A8A8D',
    fontSize: '12px',
    letterSpacing: '-0.04px',
    lineHeight: '200%',
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  button: {
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    fontWeight: '600',
    color: '#4A4A4A',
    fontSize: '16px',
    lineHeight: '24px',
    textTransform: 'lowercase',
    fontFeatureSettings: '"pnum" on, "lnum" on'
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '11px',
    letterSpacing: '0.33px',
    lineHeight: '13px',
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
    fontFeatureSettings: '"pnum" on, "lnum" on',
  }
};
